import request from "./request";

const api = {
  get2FASecret: "safety/get2FASecret",
  bind2FASecret: "safety/bind2FASecret",
  verify2FASecret: "safety/verify2FASecret",
};
export default {
  get2FASecret(parameter) {
    return request({
      url: api.get2FASecret,
      method: "POST",
      data: parameter,
    });
  },
  bind2FASecret(parameter) {
    return request({
      url: api.bind2FASecret,
      method: "POST",
      data: parameter,
    });
  },
  verify2FASecret(parameter) {
    return request({
      url: api.verify2FASecret,
      method: "POST",
      data: parameter,
    });
  },
};
